import script from "./MergeFormDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./MergeFormDetail.vue?vue&type=script&setup=true&lang=ts"

import "./MergeFormDetail.vue?vue&type=style&index=0&id=494dd8a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494dd8a7"]])

export default __exports__